module.exports = fox._r("images/stateoff/site-closed-bg.jpg", __webpack_public_path__ + "_/_/_/root/images/stateoff/site-closed-bg.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/stateoff/site-closed-bg.jpg
// module id = 186
// module chunks = 4